<template>
  <section class="hero is-default is-bold">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <my-notification :icon="'info'">
              <template #title>
                {{ $t('viewTravelsSimulator.title') }}
              </template>
              {{ $t('viewTravelsSimulator.info') }}
              <router-link class="link" :to="{ name: 'ges-1point5' }"
                ><em>Ekocentral GES</em></router-link
              >.
            </my-notification>
            <br />
            <travel-form
              :travel="travel"
              :isSimulation="true"
              :modeCreation="false"
            />
            <br />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Travel from '@/models/carbon/Travel.js'

export default {
  name: 'TravelsSimulator',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue'),
    'travel-form': () => import('@/components/carbon/forms/travels/Form.vue')
  },
  data () {
    return {
      travel: Travel.createEmpty()
    }
  }
}
</script>
